import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';

interface FormSubmitButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const FormSubmitButton: FC<FormSubmitButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button
      mode="button-secondary"
      className="mt-5 w-full max-w-[900px]"
      label={t('general.confirm') as string}
      title={t('general.confirm') as string}
      onClick={onClick}>
      {t('general.confirm')}
    </Button>
  );
};
